let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f9Y88")).then(() => parcelRequire('38lNl'));